import { Button } from "@/components/button";
import { RiArrowRightLine } from "@remixicon/react";
import { ReactNode } from "react";

interface Sublink {
  title: string;
  icon: ReactNode;
  link: string;
  action?: boolean;
}

interface EcosystemCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  link: string;
  sublinks?: Sublink[];
}

export function EcosystemCard({ title, description, icon, link, sublinks }: EcosystemCardProps) {
  const handleAddToMetaMask = () => {
    // This would be implemented with actual MetaMask integration
    alert("This would add Larissa Network to MetaMask with the following details:\n\nNetwork Name: Larissa\nRPC URL: https://rpc.larissa.network\nChain ID: 1804\nCurrency Symbol: LRS");
  };

  return (
    <div className="relative overflow-hidden rounded-xl bg-sidebar border border-border hover:border-[#FF8A3C]/50 transition-all duration-300 h-full">
      {/* Card top accent */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FF8A3C] to-[#FF8A3C]/70"></div>

      {/* Card content */}
      <div className="p-6 flex flex-col h-full">
        {/* Tool icon/title */}
        <div className="mb-4 flex items-center">
          <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center mr-3">
            <div className="text-[#FF8A3C]">{icon}</div>
          </div>
          <div>
            <h3 className="text-lg font-semibold">{title}</h3>
          </div>
        </div>

        {/* Description */}
        <p className="text-sm text-muted-foreground mb-6 flex-grow">
          {description}
        </p>

        {/* Main link */}
        <div className="mt-auto">
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-sm font-medium text-[#FF8A3C] hover:underline"
          >
            Visit {title}
            <RiArrowRightLine className="ml-1 size-4" />
          </a>

          {/* Sublinks if available */}
          {sublinks && sublinks.length > 0 && (
            <div className="mt-4 pt-4 border-t border-border">
              <div className="flex flex-wrap gap-2">
                {sublinks.map((sublink, index) => (
                  sublink.action ? (
                    <Button
                      key={index}
                      variant="outline"
                      size="sm"
                      className="text-xs flex items-center gap-1 border-[#FF8A3C]/30 hover:bg-[#FF8A3C]/10 hover:text-[#FF8A3C]"
                      onClick={handleAddToMetaMask}
                    >
                      {sublink.icon}
                      {sublink.title}
                    </Button>
                  ) : (
                    <a
                      key={index}
                      href={sublink.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button
                        variant="outline"
                        size="sm"
                        className="text-xs flex items-center gap-1 border-muted hover:bg-muted/50"
                      >
                        {sublink.icon}
                        {sublink.title}
                      </Button>
                    </a>
                  )
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
